import * as React from 'react';
import { NavLink } from 'react-router-dom';

interface NavItemProps {
    to?: string;
}

export class TopNavMenuItem extends React.Component<NavItemProps> {
    public render() {
        if (this.props.to) {
            return (
                <NavLink to={this.props.to}>
                    <div className="box">
                        {this.props.children}
                    </div>
                </NavLink>
            );
        } else {
            return (
                <div className="box">
                    {this.props.children}
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/TopNavMenuItem.tsx